import { useEffect, useRef } from 'react';
import { useSearchContext } from '@/context';
import { trackGAEvent } from '@/services';

export const useInteractionAnalytics = () => {
  const { searchQuery, facet, searchResults } = useSearchContext();
  const interactionTimer = useRef<NodeJS.Timeout | null>(null);
  const hasInteracted = useRef(false);
  const resultsContainerRef = useRef<HTMLDivElement | null>(null);
  const resultCount = searchResults?.resultCount ?? 0;

  useEffect(() => {
    hasInteracted.current = false;
    if (interactionTimer.current) {
      clearTimeout(interactionTimer.current);
    }

    const handleInteraction = () => {
      if (!hasInteracted.current) {
        hasInteracted.current = true;
        if (interactionTimer.current) {
          clearTimeout(interactionTimer.current);
        }
        trackGAEvent({
          event: 'engaged_30s',
          search_term: searchQuery ?? '',
          search_facet: facet,
          search_result_count: resultCount,
          search_engaged_count: 1,
        });
      }
    };

    const resultsContainer = resultsContainerRef.current;
    if (resultsContainer) {
      resultsContainer.addEventListener('click', handleInteraction);
    }

    if (resultCount > 0) {
      interactionTimer.current = setTimeout(() => {
        if (!hasInteracted.current) {
          trackGAEvent({
            event: 'search_no_click_30s',
            search_term: searchQuery ?? '',
            search_facet: facet,
            search_result_count: resultCount,
          });

          if (resultsContainer) {
            resultsContainer.removeEventListener('click', handleInteraction);
          }
        }
      }, 30000);
    }

    return () => {
      if (interactionTimer.current) {
        clearTimeout(interactionTimer.current);
      }
      if (resultsContainer) {
        resultsContainer.removeEventListener('click', handleInteraction);
      }
    };
  }, [searchQuery, facet, resultCount]);

  return { resultsContainerRef };
};
